import React from "react";

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/573507203553?text=Hola%20me%20puedes%20ayudar%20con%20lo%20del%20código%20de%20viaje%20por%20favor"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        backgroundColor: "#25D366",
        color: "#fff",
        borderRadius: "50%",
        width: "60px",
        height: "60px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
        cursor: "pointer",
        zIndex: 1000,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        fill="currentColor"
        width="30"
        height="30"
      >
        <path d="M16 0C7.163 0 0 7.163 0 16c0 2.938.768 5.683 2.105 8.078L.103 31.897l7.835-1.992C10.367 31.232 13.142 32 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.92c-2.616 0-5.186-.689-7.434-1.993l-.53-.315-4.65 1.182 1.223-4.554-.344-.556A13.732 13.732 0 0 1 2.08 16c0-7.635 6.202-13.838 13.84-13.838S29.76 8.365 29.76 16c0 7.637-6.202 13.84-13.76 13.84zm7.36-10.576c-.406-.203-2.407-1.19-2.782-1.33-.375-.14-.65-.204-.924.203-.276.407-1.062 1.329-1.302 1.6-.24.271-.481.306-.887.102-1.43-.712-2.368-1.271-3.38-2.993-.255-.438.254-.41.734-1.37.082-.164.041-.305-.02-.425-.062-.12-.924-2.227-1.266-3.047-.334-.814-.676-.706-.924-.718l-.788-.017c-.256 0-.66.093-1.004.452-.344.358-1.312 1.283-1.312 3.123s1.344 3.614 1.528 3.868c.186.254 2.64 4.018 6.41 5.634.898.388 1.596.62 2.141.793.898.285 1.716.245 2.364.149.72-.107 2.224-.908 2.544-1.782.32-.874.32-1.623.224-1.782-.1-.152-.374-.244-.78-.447z" />
      </svg>
    </a>
  );
};

export default WhatsAppButton;
